import * as $echarts from "echarts";
import { specialStyle } from "@/assets/utils/specialStyle";
import * as size from "../utils/chartSize";

const commonBarCharts = function (params) {
    const chartSizeA = specialStyle(document.body.clientHeight, 12)
    const chartSizeB = specialStyle(document.body.clientHeight, 14)
    const chartSizeC = specialStyle(document.body.clientHeight, 16)
    const chartSizeD = specialStyle(document.body.clientHeight, 18)
    const chartSizeE = specialStyle(document.body.clientHeight, 20)
    const chartSizeF = specialStyle(document.body.clientHeight, 22)
    const chartSizeG = specialStyle(document.body.clientHeight, 24)
    const chartSizeH = specialStyle(document.body.clientHeight, 28)
    const chartSizeI = specialStyle(document.body.clientHeight, 30)
    const chartSizeJ = specialStyle(document.body.clientHeight, 40)
    const chartSizeK = specialStyle(document.body.clientHeight, 50)
    // 特殊
    const chartSizeL = specialStyle(document.body.clientHeight, 4)
    const chartSizeM = specialStyle(document.body.clientHeight, 6)
    const chartSizeN = specialStyle(document.body.clientHeight, 10)

    let option = {
        tooltip: {
            backgroundColor: '#000',
            trigger: 'axis',
            axisPointer: {
                // 文字样式
                label: {
                    precision: 2, // 小数点精度
                },
                // 线样式
                lineStyle: {},
            },
            //浮层的文本样式
            textStyle: {
                fontSize: chartSizeB,
                fontFamily: 'Microsoft YaHei',
                color:"#FFF"
            },
            formatter: `{b} <br/> 
            <span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;
            height:10px;background-color:#09EFFF;'></span> SMT车间A流量计: {c0} <br/>
            <span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;
            height:10px;background-color:#09EFFF;'></span> SMT车间B流量计 : {c2}`,
        },
        grid: {
            left: chartSizeK,
            top: chartSizeE,
            bottom: chartSizeI,
            right: chartSizeE,
        },
        xAxis: [{
            type: 'category',
            data: ['1-3月', '1-6月', '1-9月', '1-12月'],
            axisLabel: {
                fontSize: chartSizeA,
                color: "#05ebed",
                fontFamily: 'Microsoft YaHei',
                fontWeight: 600,
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: false
            },
            splitLine: {
                lineStyle: {
                    color: 'rgba(80,224,255,0.3)',
                    type: 'dashed'
                }
            }
        }],
        yAxis: [{
            type: 'value',
            axisTick: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: '#2b4e61',
                }
            },
            axisLabel: {
                fontSize: chartSizeA,
                fontFamily: 'Microsoft YaHei',
                color: "rgba(255, 255, 255, 0.65)"
            },
            splitLine: {
                show: false,
            },
        }],
        series: [{
            type: 'bar',
            stack: 'bar',
            barWidth: '30%',
            barGap: '40%',
            itemStyle: {
                color: {
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                        offset: 0, color: 'rgba(9, 239, 255, 0.4)' // 100% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(9, 239, 255, 0)' // 0% 处的颜色
                    }],
                    global: false // 缺省为 false
                },
            },
            data: params.barData1
        },
        {
            type: 'bar',
            stack: 'bar',
            barWidth: '15%',
            barGap: '40%',
            itemStyle: {
                color: '#05ebed',
            },
            data: [20, 20, 20, 20]
        },
        {
            type: 'line',
            data: params.barData2,
            type: 'line',
            smooth: true, // 线性
            lineStyle: {
                width: 2,
                color: "#42F3FF",
            },
            itemStyle: {
                color: "#FFF",
                borderColor: "#42F3FF",
                borderWidth: 1,
            },
        },
        // {
        //     name: "阈值线",
        //     type: "line",
        //     markLine: {
        //         symbol: "none", // none为标线两端的样式为无，可更改
        //         lineStyle: {
        //             normal: {
        //                 width: 2,
        //                 color: "#D7D7D7",
        //             },
        //         },
        //         data: [
        //             {
        //                 yAxis: 0,
        //             },
        //         ],
        //         label: {
        //             show: false,
        //         },
        //     },
        // },
        ]
    };

    params.id.setOption(option, true)
}

const pictorialCharts = function (params) {
    const chartSizeA = specialStyle(document.body.clientHeight, 12)
    const chartSizeB = specialStyle(document.body.clientHeight, 14)
    const chartSizeC = specialStyle(document.body.clientHeight, 16)
    const chartSizeD = specialStyle(document.body.clientHeight, 18)
    const chartSizeE = specialStyle(document.body.clientHeight, 20)
    const chartSizeF = specialStyle(document.body.clientHeight, 22)
    const chartSizeG = specialStyle(document.body.clientHeight, 24)
    const chartSizeH = specialStyle(document.body.clientHeight, 28)
    const chartSizeI = specialStyle(document.body.clientHeight, 30)
    const chartSizeJ = specialStyle(document.body.clientHeight, 40)
    const chartSizeK = specialStyle(document.body.clientHeight, 50)
    // 特殊
    const chartSizeL = specialStyle(document.body.clientHeight, 4)
    const chartSizeM = specialStyle(document.body.clientHeight, 6)
    const chartSizeN = specialStyle(document.body.clientHeight, 10)

    // 绘制图表
    let dataList = [
        [1, 'SMTA车间', 9000],
        [2, 'SMTB车间', 8000],
        [3, '锂电池A车间', 7000],
        [4, '锂电池B车间', 6000],
        [5, '锂电池C车间', 5000],
        [6, '锂电池D车间', 4000],
    ];

    let barWidth = 10;
    let nameFontColor = '#B3CCF8';
    let nameFontSize = 12;
    let namePosition = [0, -15];
    let valueFontColor = 'rgba(244, 185, 74, 1)';
    let valueFontSize = 12;
    let valuePosition = [280, -15];

    function __getColorValue(name, val, index) {
        return {
            name: name,
            value: val,
            itemStyle: {
                color: {
                    type: "linear", x: 0, y: 0, x2: 1, y2: 0,
                    colorStops: [{
                        offset: 0,
                        color: 'rgba(85, 255, 218, 0)'
                    }, {
                        offset: 1,
                        color: 'rgba(85, 255, 218, 0.8)'
                    }],
                    globalCoord: false,
                },
                barBorderRadius: 5,
            }
        };
    };

    function __SetOption(data) {
        let lists = [];
        let values = [];
        data.forEach((item, index) => {
            lists.push(item[1]);
            values.push(__getColorValue(item[1], item[2], index));
        });

        let option = {
            grid: {
                left: '30%',
                top: chartSizeE,
                bottom: chartSizeE,
                right: chartSizeI,
            },
            yAxis: [
                {
                    type: "category",
                    inverse: true,
                    axisTick: { show: false },
                    axisLine: { show: false },
                    axisLabel: { show: false, inside: false },
                    data: lists
                }
            ],
            xAxis: {
                type: "value",
                axisTick: { show: false },
                axisLine: { show: false },
                splitLine: { show: false },
                axisLabel: { show: false },
            },
            series: [{
                type: 'bar',
                barWidth: barWidth,
                data: params.barData1,
                animationDuration: 1500,
                zlevel: 2,
                label: {
                    color: nameFontColor,
                    show: true,
                    position: 'inside',
                    position: namePosition,
                    textStyle: {
                        fontSize: nameFontSize,
                        color:"#FFF"
                    },
                    formatter: function (data) {
                        return data.name;
                    },
                },
                itemStyle:{
                    color:"#05ebed"
                }
            },
            {
                type: 'bar',
                barGap: '-100%',
                barWidth: barWidth,
                data: params.barData1,
                animationDuration: 1500,
                zlevel: 2,
                label: {
                    color: valueFontColor,
                    show: true,
                    position: 'right',
                    textStyle: {
                        fontSize: valueFontSize,
                        color:"#FFF"
                    },
                    formatter: function (a, b) {
                        return a.value;
                    }
                },
                itemStyle:{
                    color:"#137a97"
                }
            }],
            animationEasing: "cubicOut",
        };

        params.id.setOption(option, true)
    }

    __SetOption(dataList);
}

export {
    commonBarCharts, pictorialCharts
}